import { MY_ADS_PATHS } from './ProfileNav.constants';
import { ROUTES } from '@/constants/routes';

export function isProfileNavItemActive(pathname: string, href: string) {
  const [pathnamePath] = pathname.split(/[?#]/);
  const [hrefPath] = href.split(/[?#]/);

  if (hrefPath === MY_ADS_PATHS[0]) {
    return MY_ADS_PATHS.includes(pathnamePath);
  }

  if (pathnamePath === ROUTES.business) {
    return hrefPath === ROUTES.businessPackages;
  }

  if (hrefPath === ROUTES.settings) {
    return [ROUTES.settings, ROUTES.editProfile].includes(pathnamePath);
  }

  return pathnamePath === hrefPath;
}
